import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ViewChild, ElementRef, AfterViewInit, Renderer2, ChangeDetectorRef
} from '@angular/core';

import { TIME_TO_CLOSE_TOOLTIP } from '@app/constants/animations.constants';
import { TooltipOrientation } from '@shared/tooltip/entities/tooltip-orientation';
import { TooltipType, TooltipPosition, TooltipDisplay } from '@design-system/components/templates/tooltip/entities/tooltip.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class CopyToClipboardComponent implements AfterViewInit {

  @Input() copyInfo: string = '';
  @Input() parentClass: string = '';
  @Input() colorClass: string = '';
  @Input() tooltipOrientation: TooltipOrientation = TooltipOrientation.RIGHT;

  @ViewChild('copyToClipboardRef') copyToClipboardRef: ElementRef;

  public showCopyTooltip: boolean = false;

  public readonly tooltipTypes = TooltipType;
  public readonly tooltipPosition = TooltipPosition.Left;
  public readonly tooltipDisplay = TooltipDisplay;

  public readonly icons = Icon;
  public readonly iconFillColor = IconFillColor;

  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
  ) { }

  ngAfterViewInit(): void {
    if (this.copyToClipboardRef?.nativeElement) {
      this.renderer.listen(this.copyToClipboardRef.nativeElement, 'click', (event) => {
        setTimeout(() => {
          if (this.showCopyTooltip) this.toggleTooltip(false);
          this.cdr.detectChanges();
        }, TIME_TO_CLOSE_TOOLTIP);
      });
    }
  }

  public toggleTooltip(state: boolean): void {
    this.showCopyTooltip = state;
  }

  public copyToClipboard(event: Event): void {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = this.copyInfo;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    this.toggleTooltip(true);
    event.preventDefault();
    event.stopPropagation();
  }

}
